/** Baker-facing tier label — tiers 0 = flat (hidden), 1+ = stacked tier cake. */
export function formatKitchenTierLabel(tiers) {
  const n = Number(tiers);
  if (!Number.isFinite(n) || n <= 0) return null;
  const layers = n + 1;
  const tierWord = n === 1 ? "TIER" : "TIERS";
  return `${n} ${tierWord} · ${layers} layers`;
}

export function hasKitchenTierCake(tiers) {
  const n = Number(tiers);
  return Number.isFinite(n) && n > 0;
}
